module.exports = __webpack_public_path__ + "static/img/speaker-off.725b8e49.svg";